export enum BuildTypeEnum {
  default = 'default',
  canteen = 'canteen',
  companykitchen = 'companykitchen',
  refive ='refive'
};
